
module.exports = function (deliveryService, trolleyService, collectionzoneService, shopperService, shopPageStateService, $rootScope, $state, sessionContext, breakpointsService, persistentLoginService, routeService, $ocLazyLoad, moveFocus, storePickerService) {
    return {
        restrict: 'E',
        scope: {
            classes: '='
        },
        link(scope) {

            const goToCheckout = function () {
                shopPageStateService.triggerPanel('right', false);

                if (!scope.shopperService.currentUser.isGuest || sessionContext.isGuestLoggedIn(shopperService.currentUser.id)) {
                    if (breakpointsService.isCheckoutSmallFormat()) {
                        $state.go('checkout', { step: '1' });
                    } else {
                        $state.go('checkout');
                    }
                } else {
                    $state.go('checkout.checkoutLogin');
                }

                scope.isLoading = false;

            };

            scope.trolley = trolleyService;
            scope.collectionzoneService = collectionzoneService;
            scope.storePicker = storePickerService;
            scope.shopperService = shopperService;
            scope.isLoading = false;

            scope.selectDeliveryMethod = function () {
                $rootScope.$broadcast('deliveryIcon: clicked');
                collectionzoneService.toggleDeliveryWizard();
            };

            scope.isDelivery = function () {
                return deliveryService.deliveryMethod() === deliveryService.deliveryOptions.delivery;
            };

            scope.isCollect = function () {
                return deliveryService.deliveryMethod() === deliveryService.deliveryOptions.collect;
            };

            scope.isUnspecifiedDeliveryMethod = function () {
                return deliveryService.deliveryMethod() === deliveryService.deliveryOptions.none;
            };

            scope.clearDeliveryPassLimitMessage = function () {
                scope.DeliveryPassQuantityExceeded = false;
            };

            scope.clearAll = function () {
                trolleyService.clearTrolley('cart');
                scope.clearDeliveryPassLimitMessage();
            };

            scope.closeCart = function () {
                moveFocus('.header-container');
                shopPageStateService.triggerPanel('right', false);
            };

            scope.goToCheckout = () => {
                scope.isLoading = true;

                $ocLazyLoad.load(window.wowModules[3].files[0]).then(function () {
                    if (!shopperService.currentUser.isGuest) {
                        routeService.intendedRoute = {
                            to: 'checkout',
                            params: breakpointsService.isCheckoutSmallFormat() ? { step: '1' } : {}
                        };

                        // Call getSavedCards to check if user is authorised to continue
                            persistentLoginService.getLoginStatus().then(function () {
                                routeService.intendedRoute = {}; //Clear intention as user is authorised for checkout
                                goToCheckout();
                            },
                            function () {
                                scope.isLoading = false;
                            });
                    } else {
                        goToCheckout();
                    }
                });

            };

            scope.loadingCheckout = false;

            scope.$on('deliveryWindow:changeDeliveryTime', function () {
                if (!collectionzoneService.showDeliveryWizard) {
                    collectionzoneService.toggleDeliveryWizard();
                }
            });

            scope.$on('deliveryWindow:changePickupTime', function () {
                // if the delivery wizard isn't already open, show it
                if (!collectionzoneService.showDeliveryWizard) {
                    collectionzoneService.toggleDeliveryWizard();
                }
            });

            scope.$watch('trolley.salePriceTotal', function () {
                scope.canCheckout = scope.trolley.salePriceTotal > 0;
            });
        },
        template: require('./collection-zone-header-template.html').trim()
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/collection-zone-header-directive.js
 **/